import { CropCategory } from './CropCategory';

export type CropType = 'Intensivo' | 'Extensivo';

export enum CropLevels {
  LOW = 'Low',
  MEDIUM_LOW = 'Medium Low',
  MEDIUM = 'Medium',
  MEDIUM_HIGH = 'Medium High',
  HIGH = 'High',
}

export const cropYielLevelsMap = {
  [CropLevels.LOW]: '-10 Ton/Ha',
  [CropLevels.MEDIUM_LOW]: '10-15 Ton/Ha',
  [CropLevels.MEDIUM]: '15-20 Ton/Ha',
  [CropLevels.MEDIUM_HIGH]: '20-40 Ton/Ha',
  [CropLevels.HIGH]: '40+ Ton/Ha',
};

export const cropAverageCostLevelsMap = {
  [CropLevels.LOW]: '-12000 MXN',
  [CropLevels.MEDIUM_LOW]: '12000-25000 MXN',
  [CropLevels.MEDIUM]: '25000-50000 MXN',
  [CropLevels.MEDIUM_HIGH]: '50000-90000 MXN',
  [CropLevels.HIGH]: '90000+ MXN',
};

export const cropAveragePriceLevelsMap = {
  [CropLevels.LOW]: '-15000 MXN',
  [CropLevels.MEDIUM_LOW]: '15000-30000 MXN',
  [CropLevels.MEDIUM]: '30000-60000 MXN',
  [CropLevels.MEDIUM_HIGH]: '60000-100000 MXN',
  [CropLevels.HIGH]: '100000+ MXN',
};

export interface CropVariety {
  id: number;
  cropId: number;
  variety: string;
}

export interface Crop {
  id: number;
  nameMx: string;
  nameEn: string | null;
  position: number;
  categoryId?: number;
  category: CropCategory | null;
  type: CropType | null;
  yiel: CropLevels | null;
  averageCost: CropLevels | null;
  averagePrice: CropLevels | null;
  varieties?: CropVariety[] | string[];
  varietiesNames?: string[];
}
